<template>
    <section class="pda-default">
        <div v-if="previewData.type">

            <div class="t-subtitle2 mb8">                            
                {{$t('611')}}
                <!-- 미리보기 -->
            </div>
            <component :is="previewData.type.value"
                :previewData="previewData"
                :orientationMode="orientationMode"
                class="mgt-8"
            ></component>
        </div>

        <div v-if="summeryData">
            <div class="mdc-card mdc-elevation--z3 mgt-16">
                <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                    {{$t('612')}}
                    <!-- 학습 목표 -->
                </div>
                <div class="t-body2 summery-list" >
                    <ul>
                        <li v-for="(summery, index) in summeryData" :key="index" class="mgt-16 pdl-16 pdr-16">
                            <div v-if="summeryData.length > 1">{{summery.name}}</div>
                            <div class="t-body3 t-color-content1  mgt-8 pdb-16">
                                {{summery.purpose}}
                            </div>
                        </li>
                    </ul>
                    
                </div>                
            </div>
        </div>
        
        <div class="mdc-card mdc-elevation--z3 mgt-15" v-if="reviewData.length">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{reviewSummaryData.average}}
                <span class="t-body3">
                    {{$t('613')}}
                    <!-- 평균 평점 -->
                </span>
            </div>
            <ReviewListItem
                v-for="(review, index) in reviewData" :key="index"
                :review="review"
            ></ReviewListItem>
            <hr class="divider mgt-16">
            <div class="pdt-8 pdb-8 pdl-8 pdr-8">
                <button class="mdc-button btn-white" @click="moveReview()">
                    {{$t('614')}}
                    <!-- 리뷰 더보기 -->
                </button>
            </div>
        </div>

        <div class="mdc-card mdc-elevation--z3 mgt-15 pdb-16" v-if="skillsetData.length">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('615')}}
                <!-- 역량 -->
            </div>
            <div v-for="(skillset, index) in skillsetData" :key="index">
                <div class="d-flex flex-row pdt-16 mgl-8 mgr-8">
                    <div class="pdl-8 pdr-8" v-if="skillset.standard.image">
                        <img :src="skillset.standard.image" class="circle profile">
                    </div>
                    <div class="pdl-8 pdr-8">
                        <div class="t-body2 mgt-4">
                            {{skillset.standard.code}}
                            <div class="t-body3 mgt-3" v-if="skillset.standard.name">
                                {{skillset.standard.name}}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex flex-row mgt-14" v-if="skillsetData.length > index+1">
                    <div class="mgl-16 mgr-16 w-40" v-if="skillset.standard.image"></div>
                    <div class="flex-grow-1">
                        <hr class="divider">
                    </div>
                </div>

                
            </div>
        </div>


        <div class="mdc-card mdc-elevation--z3 mgt-15 pdb-16" v-if="teacher">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16">
                {{$t('616')}}
                <!-- 강사 -->
            </div>
            
            <div class="d-flex flex-row pdt-16 mgl-8 mgr-8">
                <div class="pdl-8 pdr-8">
                    <img :src="teacher.profile" v-if="teacher.profile" class="circle profile">
                    <img src="@/images/icon/person_icon1.png" v-else class="circle profile">
                </div>
                <div class="pdl-8 pdr-8">
                    <div class="t-body1">
                        {{teacher.name ? teacher.name.fullName : $t("S10082")}}
                        <div class="t-body3 mgt-3 t-color-gray2">
                            {{teacher.userId}}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="mdc-card mdc-elevation--z3 mgt-15 pdb-16" v-if="periodData">
            <div class="t-subtitle2 mgt-16 mgl-16 mgr-16 d-flex flex-row justify-content-between">
                {{$t('617')}}
                <!-- 기간정보 -->
                <div @click="togglePeriod">
                    <span class="material-icons">
                        {{periodShowState ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}}                                    
                    </span>
                </div>
            </div>
            
            <div v-show="periodShowState">

                <div class="d-flex flex-row pdt-16 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-gray2">
                        {{$t('636')}}
                        <!-- 수강신청기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{this.displayPeriod(periodData.register)}}
                    </div>
                </div>

                <div class="d-flex flex-row pdt-26 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-gray2">
                        {{$t('637')}}
                        <!-- 수강 취소 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{this.displayPeriod(periodData.registerCancel)}}
                    </div>
                </div>

                <div class="d-flex flex-row pdt-26 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-gray2">
                        {{$t('638')}}
                        <!-- 학습 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{this.displayPeriod(periodData.learning)}}
                    </div>
                </div>

                <div class="d-flex flex-row pdt-26 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-gray2">
                        {{$t('639')}}
                        <!-- 복습 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{this.displayPeriod(periodData.review)}}
                    </div>
                </div>

                <div class="d-flex flex-row pdt-26 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-gray2">
                        {{$t('640')}}
                        <!-- 정규 평가 응시 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{this.displayPeriod(periodData.midterm)}}
                    </div>
                </div>

                <div class="d-flex flex-row pdt-26 mgl-8 mgr-8 t-body3">
                    <div class="pdl-8 pdr-8 flex-1 t-color-gray2">
                        {{$t('641')}}
                        <!-- 성적 조회 기간 -->
                    </div>
                    <div class="pdl-8 pdr-8 flex-1">
                        {{this.displayPeriod(periodData.scoreConfirm)}}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
/**
 * 차수 상세 과정개요 탭 컴포넌트(degree view summary tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import degreeApi from '@/api/degreeApi.js'
import ReviewListItem from '../review/ListItem.vue'

export default {
    props: ['teacher'],

    components: {
        'VIDEO': () => import('../preview/Video.vue'),
        'SLIDE': () => import('../preview/Slide.vue'),
        ReviewListItem
    },
    
    data() {
        return {
            previewData: {type: null},
            periodData: null,
            summeryData: null,
            periodShowState: false,
            skillsetData: [],
            reviewData: [],
            reviewSummaryData: {},
            orientationMode : ''
        }
    },

    mounted() {
        this.fetchData()
    },
    methods: {
        
        // 과정정보 API 호출 및 데이터 설정(call api data)
        fetchData() {
            let responseData = null
            let params = this.setParams()

            // 미리보기(preview)
            degreeApi.guestLearnOnlineViewPreview(params).then((response) => {
                this.previewData = response.data.data
            }).catch((err) => {
            })

            // 기간정보(period)
            degreeApi.guestLearnOnlineViewPeriod(params).then((response) => {
                this.periodData = response.data.data
            }).catch((err) => {
            })

            // 학습목표(summery)
            degreeApi.guestLearnOnlineViewSummery(params).then((response) => {
                this.summeryData = response.data.data
            }).catch((err) => {
            })

            // 스킬셋(skillset)
            degreeApi.guestLearnOnlineViewSkillset(params).then((response) => {
                this.skillsetData = response.data.data                
            }).catch((err) => {
            })

            // 과정 리뷰 목록(review list)
            degreeApi.guestLearnOnlineViewReview(params).then((response) => {
                this.reviewData = response.data.data.content
            }).catch((err) => {
            })

            //과정 리뷰 평점(review summary)
            degreeApi.guestLearnOnlineViewReviewSummary(params).then((response) => {
                this.reviewSummaryData = response.data.data
            }).catch((err) => {
            })
            
        },

        // 파라미터 설정(set parameter)
        setParams() {
            const params = {
                degreeId: this.$route.params.degreeId,
                language: JSON.parse(localStorage.getItem('languageInfo')).code,
                size: 3
            }
            return params
        },

        // 기간정보 노출 설정(set period show state)
        togglePeriod() {
            this.periodShowState = !this.periodShowState
        },

        // 날짜 변환(change date format)
        displayPeriod(dateInfo) {
            let startDate = this.$moment(dateInfo.start).format('l')
            let endDate = dateInfo.unlimited ? this.$t('50013') : this.$moment(dateInfo.end).format('l')
            return startDate + ' ~ ' + endDate
        },

        // 리뷰 목록 이동(move to review)
        moveReview() {
            this.$router.push({
                name: 'DegreeReviewList',
                params: this.$route.params,
                query: this.$route.query,
            })
        }
        
    }
}
</script>